import React from 'react';
import PropTypes from 'prop-types';
import Reorder from 'react-reorder';
import cx from 'classnames';
import { Drawer, Dropdown, Menu, Modal, Input, Tag, List, Card, Button, message } from 'antd';
import {
  WarningOutlined,
  MenuOutlined,
  PlusOutlined,
  DownOutlined,
  BlockOutlined,
  EllipsisOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { allBlocks } from '../../components/editor/blocks/allBlocks';

const { CheckableTag } = Tag;


// Remember when changing to a class compoenent, this is being used as a ref in
// Editor. Change it by lifting state up
export class BlockDrawer extends React.Component {
  state = {
    addModalVisible: false,

    insertIndex: null,

    renameMode: false,
    renameIndex: null,

    selectedTags: [],
  };

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentBlocks: PropTypes.array.isRequired,

    onBlocksReorder: PropTypes.func.isRequired,
    onBlockDelete: PropTypes.func.isRequired,
    onBlockRename: PropTypes.func.isRequired,
    onBlockInsert: PropTypes.func.isRequired,
    // onRef: PropTypes.func.isRequired,
  };

  // componentDidMount() {
  //   this.props.onRef(this);
  // }
  //
  // componentWillUnmount() {
  //   this.props.onRef(undefined);
  // }

  menuClicked = ({ item, key }) => {
    const { burlsafe, bindex } = item.props;
    if (key === 'block:insert_above') {
      this.setState({
        addModalVisible: true,
        insertIndex: bindex,
      });
    }
    else if (key === 'block:insert_below') {
      this.setState({
        addModalVisible: true,
        insertIndex: bindex + 1,
      });
    }
    else if (key === 'block:rename') {
      this.setState({
        renameMode: true,
        renameIndex: bindex,
      });
    }
    else if (key === 'block:delete') {
      Modal.confirm({
        icon: <WarningOutlined />,
        title: 'Confirm deletion',
        content: 'This block will be removed from your page, along with your edits within it.',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Never mind',
        onOk: () => { this.props.onBlockDelete(burlsafe); },
      });
    }
  }

  onAddMoreBlockBtnClick = () => {
    const { currentBlocks } = this.props;
    this.setState({
      addModalVisible: true,
      insertIndex: currentBlocks.length,
    });
  };

  onInputPressEnter = (e) => {
    const { currentBlocks } = this.props;
    const currentBlock = currentBlocks[this.state.renameIndex];
    const newName = e.target.value;
    this.setState({
      renameMode: false,
      renameIndex: null,
    });
    this.props.onBlockRename(currentBlock.urlsafe, newName);
  };

  onInputBlur= () => {
    this.setState({
      renameMode: false,
      renameIndex: null,
    });
  };

  tags = ['Cover', 'CTA', 'Benefit', 'Testimonial', 'Pricing', 'Divider'];
  handleTagClick = (tag, checked) => {
    const { selectedTags } = this.state;
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter(t => t !== tag);
    this.setState({ selectedTags: nextSelectedTags });
  };

  handleAddBlockClick = (e, block) => {
    e.preventDefault();
    this.props.onBlockInsert(this.state.insertIndex, block);
    this.setState({
      insertIndex: (this.state.insertIndex + 1),
    });
    message.success('Block added successfully');
  }

  render() {
    const { currentBlocks } = this.props;
    const { selectedTags } = this.state;

    const isEmpty = currentBlocks.length === 0;

    const emptyState = (
      <div className="text-center mt-4">
        <h6>No block added yet</h6>
        <div className="my-4 text-secondary">
          Start by adding pre-designed blocks to your page.
          Blocks you add will appear here.
        </div>
        <Button type="primary" icon={<BlockOutlined />} onClick={this.onAddMoreBlockBtnClick}>Add Blocks</Button>
      </div>
    );

    const blockOverflowMenu = (urlsafe, index) => (
      <Menu onClick={this.menuClicked}>
        <Menu.Item key="block:insert_above" burlsafe={urlsafe} bindex={index}>
          Insert blocks above
        </Menu.Item>
        <Menu.Item key="block:insert_below" burlsafe={urlsafe} bindex={index}>
          Insert blocks below
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="block:rename" burlsafe={urlsafe} bindex={index}>
          Rename
        </Menu.Item>
        <Menu.Item key="block:delete" burlsafe={urlsafe} bindex={index}>
          <span className="text-danger">
            Delete
          </span>
        </Menu.Item>
      </Menu>
    );

    const filteredBlocks = (selectedTags.length === 0) ? allBlocks : allBlocks.filter(
      block => (block.tags.filter(value => selectedTags.indexOf(value) !== -1).length !== 0)
    );

    const renameClass = this.state.renameMode ? 'rename' : '';

    const reorderNode = (
      <React.Fragment>
        <div className="text-secondary small text-center mb-3">
          Drag & drop to reorder, and tap on the overflow button to remove.
        </div>
        <Reorder
          // Refer to documentation on rework branch - https://github.com/JakeSidSmith/react-reorder/tree/rework
          className="block__reorder__container"
          reorderId="reorderBlockId" // Unique ID that is used internally to track this list (required)
          reorderGroup="reorderGroup" // A group ID that allows items to be dragged between lists of the same group (optional)
          component="div" // Tag name or Component to be used for the wrapping element (optional), defaults to 'div'
          placeholderClassName="placeholder" // Class name to be applied to placeholder elements (optional), defaults to 'placeholder'
          draggedClassName="dragged" // Class name to be applied to dragged elements (optional), defaults to 'dragged'
          lock="horizontal" // Lock the dragging direction (optional): vertical, horizontal (do not use with groups)
          holdTime={50} // Default hold time before dragging begins (mouse & touch) (optional), defaults to 0
          touchHoldTime={150} // Hold time before dragging begins on touch devices (optional), defaults to holdTime
          mouseHoldTime={50} // Hold time before dragging begins with mouse (optional), defaults to holdTime
          onReorder={this.props.onBlocksReorder} // Callback when an item is dropped (you will need this to update your state)
          autoScroll={true} // Enable auto-scrolling when the pointer is close to the edge of the Reorder component (optional), defaults to true
          disabled={this.state.renameMode} // Disable reordering (optional), defaults to false
          disableContextMenus={true} // Disable context menus when holding on touch devices (optional), defaults to true
          placeholder={
            <div className="block__placeholder rounded-sm" /> // Custom placeholder element (optional), defaults to clone of dragged element
          }
        >
          {
            currentBlocks.map((block, index) => (
              <div key={block.urlsafe} className={cx(
                "block__reorder__item rounded-sm px-2",
                "d-flex align-items-center flex-nowrap",
                {
                  rename: this.state.renameMode,
                  'shadow-sm': !this.state.renameMode,
                }
              )}>
                <MenuOutlined className={cx("mr-2 text-muted", {
                  'd-none': (index === this.state.renameIndex),
                })} />
                {
                  (index === this.state.renameIndex) ? (
                    <Input
                      placeholder="Name this Block"
                      defaultValue={block.name}
                      onPressEnter={this.onInputPressEnter}
                      onBlur={this.onInputBlur}
                      autoFocus
                      className="block_name_input"
                    />
                  ) : (
                    <div className="block__name">{block.name}</div>
                  )
                }
                <Dropdown
                  overlay={blockOverflowMenu(block.urlsafe, index)}
                  placement="bottomRight" trigger={["click"]}
                  className={cx("block_item_overflow", {
                    'd-none': (index === this.state.renameIndex),
                  })}
                >
                  <DownOutlined />
                </Dropdown>
              </div>
            ))
          }
        </Reorder>
        <Button icon={<PlusOutlined />} className="mt-3" type="dashed" block onClick={this.onAddMoreBlockBtnClick}>Add more blocks</Button>
      </React.Fragment>
    );

    const drawerContent = isEmpty ? emptyState : reorderNode;

    return (
      <div>
        <Drawer
          title="Arrange Blocks"
          placement="right"
          className="editor__drawer"
          closable={true}
          onClose={this.props.onClose}
          visible={this.props.visible}
          width={300}
        >
          { drawerContent }
        </Drawer>

        <Modal
          title="Choose Blocks"
          zIndex={1001}
          footer={null}
          width={768}
          visible={this.state.addModalVisible}
          onCancel={() => this.setState({ addModalVisible: false })}
          destroyOnClose={true}
        >
          <div className="d-flex block_modal_header mb-3 flex-wrap">
            <React.Fragment>
              <CheckableTag
                className="mb-2" key="all" checked={selectedTags.length === 0}
                onChange={() => { this.setState({ selectedTags: [] }); }}
              >
                All
              </CheckableTag>
              {this.tags.map(tag => (
                <CheckableTag
                  className="mb-2" key={tag}
                  checked={selectedTags.indexOf(tag) > -1}
                  onChange={checked => this.handleTagClick(tag, checked)}
                >
                  {tag}
                </CheckableTag>
              ))}
            </React.Fragment>
          </div>

          <List
            className="editor__block__list"
            grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
            dataSource={filteredBlocks}
            renderItem={block => (
              <List.Item>
                <Card
                  bodyStyle={{ padding: 12 }}
                  bordered={false}
                  className="shadow-sm rounded overflow-hidden"
                  cover={
                    <img
                      src={require(`assets/media/editor/blocks/${block.thumb}.jpg`)}
                      alt={`Preview for ${block.name}`}
                    />
                  }
                >
                  <Card.Meta
                    title={block.name}
                    description={block.description}
                  />
                  <div className="text-right mt-3">
                    <Button
                      type="link"
                      icon={<DownloadOutlined />}
                      style={{ paddingRight: 0 }}
                      onClick={(e) => this.handleAddBlockClick(e, block)}
                    >
                      Add block
                    </Button>
                  </div>
                </Card>
              </List.Item>
            )}
            locale={{ emptyText: 'No blocks' }}
          />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/BlockDrawer.jsx